import script from "./ActionButtons.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActionButtons.vue?vue&type=script&setup=true&lang=ts"

import "./ActionButtons.vue?vue&type=style&index=0&id=59bd6f58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59bd6f58"]])

export default __exports__